// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3kKk8{display:block;position:relative}._3-Pfp{margin-bottom:1.5rem}._2pm2l{background:#f5f9ff;border:none;border-radius:10rem;font-size:12px;font-size:1.2rem;height:36px;height:3.6rem;line-height:1}html[dir=ltr] ._2pm2l{padding-right:5rem}html[dir=rtl] ._2pm2l{padding-left:5rem}._2pm2l::-webkit-input-placeholder{color:#6f7ea2}._2pm2l::-moz-placeholder{color:#6f7ea2}._2pm2l:-ms-input-placeholder{color:#6f7ea2}._2pm2l::-ms-input-placeholder{color:#6f7ea2}._2pm2l::placeholder{color:#6f7ea2}._1VRmG{fill:#6f7ea2;height:14px;height:1.4rem;margin-top:-.7rem;position:absolute;top:50%;width:14px;width:1.4rem}html[dir=ltr] ._1VRmG{right:20px;right:2rem}html[dir=rtl] ._1VRmG{left:20px;left:2rem}", ""]);
// Exports
exports.locals = {
	"searchPatients": "_3kKk8",
	"searchPatients__formGroup": "_3-Pfp",
	"searchPatients__formGroup__input": "_2pm2l",
	"searchPatients__icon": "_1VRmG"
};
module.exports = exports;
